import { imageArrayPropType, themePropType } from './sharedPropTypes';
import PropTypes from 'prop-types';
import React from 'react';
const LinkList = ({theme, links, onClick}) => {
    const flowerDay = require('../static/images/assetComponents/flower/flowerFlatDay.webp');
    const flowerNight = require('../static/images/assetComponents/flower/flowerFlatNight.webp');
    return(
        <div className="websiteLinkList">
            {links.map((link, index) => (
                <div
                    key={index}
                    className='linkItem'
                    onClick={() => onClick && onClick(link)}
                >
                    <img 
                        src={theme === 'light' ? flowerDay : flowerNight} 
                        alt="" 
                        className="linkFlower"
                    />
                    <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="linkAnchor"
                        style={{ color: theme === 'light' ? '#614531' : '#dbecda' }}
                    >
                        {link.text}
                    </a>
                </div>
            ))}
        </div>
    );
};
LinkList.propTypes = {
    theme: themePropType,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        icon: PropTypes.string //optional custom icon
      })
    ).isRequired,
    onClick: PropTypes.func
  };

export default LinkList;